import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Parejas donde uno o ambos miembros tienen ADHD (diagnosticado o sospechado).', 'Personas que sienten que han pasado de ser "pareja" a ser "padre/madre" de su compañero/a.', 'Adultos con ADHD que viven con una culpa constante por no poder mantener el orden básico.', 'Parejas que se aman pero están al límite del divorcio por fricciones domésticas diarias.'];
  const isNotFor = ['Personas que buscan una cura médica o farmacológica para el ADHD.', 'Quienes no están dispuestos a colocar un imán o un papel visual en su pared.', 'Parejas que creen que el ADHD es solo una falta de disciplina o pereza.'];
  return <section className="py-16 md:py-24 bg-[#1e293b]" data-id="element-170">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-171">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-172">
          {/* FOR */}
          <div className="bg-slate-900/50 p-8 rounded-3xl border border-teal-900/30" data-id="element-173">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-174">
              <span className="bg-teal-500/20 p-2 rounded-lg" data-id="element-175">
                <CheckCircleIcon className="w-6 h-6 text-teal-400" data-id="element-176" />
              </span>
              ¿Para Quién Es Este Sistema?
            </h3>
            <ul className="space-y-5" data-id="element-177">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-178">
                  <CheckCircleIcon className="w-6 h-6 text-teal-500 flex-shrink-0 mt-0.5" data-id="element-179" />
                  <span className="text-slate-300 leading-relaxed" data-id="element-180">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* NOT FOR */}
          <div className="bg-slate-900/50 p-8 rounded-3xl border border-red-900/20" data-id="element-181">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-182">
              <span className="bg-red-500/10 p-2 rounded-lg" data-id="element-183">
                <XCircleIcon className="w-6 h-6 text-red-400" data-id="element-184" />
              </span>
              ¿Para Quién NO Es?
            </h3>
            <ul className="space-y-5" data-id="element-185">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-186">
                  <XCircleIcon className="w-6 h-6 text-red-500/70 flex-shrink-0 mt-0.5" data-id="element-187" />
                  <span className="text-slate-400 leading-relaxed" data-id="element-188">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}